import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor(private platform: Platform) {}

  /**
   * Gets the deviceType from Ionic's platform service.
   */
  getDeviceType(): string {
    if (this.platform.is('tablet')) {
      return 'tablet';
    }
    if (this.platform.is('mobile')) {
      return 'mobile';
    }
    return 'unknown';
  }

  /**
   * Gets the os from Ionic's platform service.
   */
  getOs(): string {
    if (this.platform.is('ios')) {
      return 'ios';
    }
    if (this.platform.is('android')) {
      return 'android';
    }
    return 'unknown';
  }
}
